var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.38 55.027l-6.388 2.746 5.916 2.532 6.86-2.532-6.388-2.746zm-9.604 3.433l-.214 12.358 9.346 4.12v-12.83l-9.132-3.647zm19.208 0l-8.446 3.22v12.1l8.446-3.433V58.46zM88.06 20.012l-6.432 2.746 5.96 2.532 6.86-2.532-6.388-2.746zm-8.918 3.648V36.02l7.974 2.318.258-11.243-8.232-3.433zm17.836.687l-7.546 3.22V39.7l7.546-3.433v-11.93zm-39.124 13.06l-6.388 2.746 5.916 2.532 6.86-2.532-6.388-2.746zm-9.604 3.433l-.214 12.358 9.346 4.12v-12.83l-9.132-3.647zm19.208 0l-8.446 3.22v12.1l8.446-3.433V40.838zm10.976-3.89l-6.388 2.746 5.916 2.532 6.86-2.532-6.388-2.746zm-9.604 3.433l-.214 12.358 9.346 4.12V44.03l-9.132-3.648zm19.208 0l-8.446 3.22v12.1l8.446-3.433V40.383zm20.123-20.37l-6.388 2.746L107.7 25.3l6.86-2.532-6.388-2.746zm-9.604 3.433l-.214 12.358 9.346 4.12v-12.83l-9.132-3.648zm19.208 0l-8.446 3.22v12.1l8.446-3.433V23.445z",
    fill: "#f7a80d",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/AWS.8ae6b288df48e0b698c840d9e1fbea0c.svg";
export { ForwardRef as ReactComponent };